/**
 * Token colours for an event description rendered as rich text.
 *
 * `prose` paints running text grey and `dark:prose-invert` a lighter grey, so
 * on its own a description reads dimmer than the text around it. Every colour
 * the typography plugin sets is pinned to the foreground token here, which
 * follows both themes. Links keep the accent.
 */
export const DESCRIPTION_PROSE_COLOURS =
  "text-foreground prose-headings:text-foreground prose-p:text-foreground prose-li:text-foreground prose-strong:text-foreground prose-blockquote:text-foreground prose-a:text-lit";

/**
 * An event description in the page's own type: the body font, at the size and
 * line height of the chapter blurbs in the highlight blocks (`text-lg
 * leading-normal`), in the foreground colour. Nothing is set in the display
 * face, so the first paragraph is not an opening line. Headings inside the
 * rich text keep the typography plugin's scale, which is relative to that size.
 *
 * The plugin's own `.prose` sets a 16px size and a 1.75 line height on the same
 * element and comes later in the stylesheet, so the two are written as
 * important arbitrary properties holding what `text-lg` and `leading-normal`
 * hold. They are not the utilities because `cn` runs tailwind-merge over a
 * card's class list, which reads `text-lg!` as a colour and drops it next to
 * `text-foreground`. Paragraphs, lists and the rest inherit the line height;
 * the plugin sets none of its own on them.
 */
export const DESCRIPTION_PROSE_CLASS = `prose max-w-none [font-size:1.125rem]! [line-height:1.5]! wrap-anywhere dark:prose-invert ${DESCRIPTION_PROSE_COLOURS}`;
